import React, { useState } from 'react';

import Login from '..';
import Text from 'components/Text';
import { Button } from 'components/Button';
import { Row } from 'components/Layout/Grid';
import Input from 'components/Input';
import { PageViewTracker } from 'components/ApplicationInsights/pageViewTracker';

import TicketService from 'services/ticket.service';

import { DocumentStr } from 'utils/Document';
import { PhoneNumberOutput, PhoneNumberTest } from 'utils/PhoneNumber';
import { ValidateEmail } from 'utils/Email';

import IconArrowLeft from 'img/arrow-left.svg';
import IconNewPasswordSuccess from 'img/request-new-password-success.svg';

const SignUpProtocol: React.FC = () => {
  const [nameInput, setNameInput] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [enterpriseNameInput, setEnterpriseNameInput] = useState('');
  const [cnpjInput, setCnpjInput] = useState('');
  const [phoneInput, setPhoneInput] = useState('');

  const _ticketService = new TicketService();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const makeRequestOnEnterPress = (e: any) => {
    if (e.keyCode !== 13) return;
    return sendUserData();
  };

  async function sendUserData() {
    setErrorMessage('');

    if (!nameInput) return setErrorMessage('Campo nome é requerido');
    if (nameInput.length < 5)
      return setErrorMessage(
        'Campo nome precisa conter pelo menos 5 caracteres'
      );

    if (!emailInput) return setErrorMessage('Campo e-mail é requerido');
    if (!ValidateEmail(emailInput)) return setErrorMessage('Campo e-mail inválido');

    if (!enterpriseNameInput)
      return setErrorMessage('Campo nome da empresa é requerido');
    if (enterpriseNameInput.length < 5)
      return setErrorMessage(
        'Campo nome da empresa precisa conter pelo menos 5 caracteres'
      );

    if (!cnpjInput) return setErrorMessage('Campo cnpj é requerido');

    if (!phoneInput) return setErrorMessage('Campo telefone é requerido');
    if (!PhoneNumberTest(PhoneNumberOutput(phoneInput)))
      return setErrorMessage('Digite um telefone válido');

    setLoading(true);
    setSuccess(false);

    _ticketService
      .registerCustomerAnonymous({
        name: nameInput,
        email: emailInput,
        enterpriseName: enterpriseNameInput,
        cnpj: cnpjInput,
        phone: phoneInput,
      })
      .then(() => setSuccess(true))
      .catch((err) => {
        setLoading(false);
        setErrorMessage(
          err?.response?.data?.data || 'Erro ao realizar requisição'
        );
      });
  }

  return (
    <Login>
      <PageViewTracker />
      {!success ? (
        <div className="animated fadeIn">
          <Text size={24} className="color-primary font-bold">
            Faça seu cadastro
          </Text>
          <Text className="color-blue-gray text-wrap mt-2" size={14}>
            Favor preencher os campos abaixo para que nosso time de atendimento
            valide suas credenciais para autorizar o acesso ao Customer Care.
          </Text>
          <div className="flex-col relative">
            <div className="form-grid">
              <Input
                disabled={loading}
                onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
                onChange={(e: any) => setNameInput(e.target.value)}
                value={nameInput}
                type="text"
                required
                placeholder="Seu nome"
                spellCheck="false"
                autoFocus
                className="w-100 mt-2"
              />

              <Input
                disabled={loading}
                onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
                onChange={(e: any) => setEmailInput(e.target.value)}
                value={emailInput}
                type="email"
                required
                placeholder="E-mail"
                spellCheck="false"
                className="w-100 mt-2"
              />

              <Input
                disabled={loading}
                onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
                onChange={(e: any) => setEnterpriseNameInput(e.target.value)}
                value={enterpriseNameInput}
                type="text"
                required
                placeholder="Nome da empresa"
                spellCheck="false"
                className="w-100 mt-2"
              />

              <Input
                disabled={loading}
                onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
                onChange={(e: any) => setCnpjInput(e.target.value)}
                value={DocumentStr({ type: 'cnpj', value: cnpjInput })}
                type="text"
                required
                placeholder="Cnpj"
                spellCheck="false"
                className="w-100 mt-2"
              />

              <Input
                disabled={loading}
                onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
                onChange={(e: any) => setPhoneInput(e.target.value)}
                value={PhoneNumberOutput(phoneInput)}
                type="text"
                required
                placeholder="Telefone de contato"
                spellCheck="false"
                className="w-100 mt-2"
              />
            </div>
            {errorMessage && (
              <Text className="color-danger mt-2 animated fadeIn" size={14}>
                {errorMessage}
              </Text>
            )}
            <div className="d-flex justify-between align-center mt-3">
              <button
                // eslint-disable-next-line no-return-assign
                onClick={() => (window.location.href = '/')}
                className="no-style inline-flex"
              >
                <img src={IconArrowLeft} alt="" />
                <Text className="ml-2" size={14}>
                  Retornar
                </Text>
              </button>
              <Button
                className="w-md-60 action-button"
                isRequesting={loading}
                disabled={loading}
                onClick={sendUserData}
                width={105}
              >
                <Text className="color-white">Enviar Dados</Text>
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="animated fadeIn my-5">
          <Row className="animated fadeIn justify-center align-center">
            <img
              src={IconNewPasswordSuccess}
              alt=""
              style={{ height: 96, width: 96 }}
            />
          </Row>
          <Text
            size={14}
            className="color-blue-gray text-wrap mt-5 px-2 text-center"
          >
            Seus dados foram enviados com sucesso. Nossa equipe interna irá
            validar as informações e a Mel lhe enviará um convite de cadastro
            para o seu e-mail.
          </Text>
          <a href="/" className="no-style d-flex align-center mt-5">
            <img src={IconArrowLeft} alt="" />
            <Text className="ml-2" size={14}>
              Retornar
            </Text>
          </a>
        </div>
      )}
    </Login>
  );
};

export default SignUpProtocol;
